const styles = (theme) => ({
  sectionTitle: {
    scrollMarginTop: 95,
    textAlign: 'center',
    color: theme.palette.common.blue400,
    fontSize: theme.typography.fontSize32,
    lineHeight: 1.6,
    marginBottom: 32,
  },
});

export default styles;
